export const SVG_NS = 'http://www.w3.org/2000/svg';
